<template>
  <modal 
    name="add-client-modal" 
    :pivotY="0.2"
    :width="'620px'"
    height="auto">

    <div class="modal-header">
      <div class="modal-title">
        Please select your option for adding a new client
      </div>

      <a href="#"
        @click.prevent="$modal.hide('add-client-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>
    
    <div class="modal-body">
      <div class="flex flex-wrap -mx-2">
        <div :class="{
          'w-1/3 px-2' : showMercuryOption,
          'w-1/2 px-2' : !showMercuryOption
        }">
          <button class="item-button" v-on:click="addNewClient">
            <img src="https://img.icons8.com/color/96/000000/laptop--v1.png" class="inline w-16" />
            <div class="mt-2 text-sm">Add clients directly via {{ getAppName }}</div>
          </button>
        </div>

        <div :class="{
          'w-1/3 px-2' : showMercuryOption,
          'w-1/2 px-2' : !showMercuryOption
        }">
          <button class="item-button" v-on:click="addNewClientViaTemplate">
            <img src="https://img.icons8.com/color/96/000000/user-folder.png" class="inline w-16" />
            <div class="mt-2 text-sm">Add client using a client template</div>
          </button>
        </div>

        <div v-if="showMercuryOption" :class="{
          'w-1/3 px-2' : showMercuryOption,
          'w-1/2 px-2' : !showMercuryOption
        }">
          <button class="item-button" v-on:click="addViaMercury">
            <img src="https://img.icons8.com/color/96/000000/download-from-cloud.png" class="inline w-16" />
            <div class="mt-2 text-sm">Add opportunities from Mercury</div>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    methods : {
      addNewClientViaTemplate() {
        this.$modal.hide('add-client-modal')
        this.$modal.show('add-client-via-template-modal')
      },

      addViaMercury() {
        
        if(this.$store.state[this.$store.state.view + 'Module'].broker.mercury_api_key != null && 
           this.$store.state[this.$store.state.view + 'Module'].broker.mercury_api_token != null) {
          this.$router.push({ 
            name : 'mercury-opportunity-import' 
          })
        }

        else {
          this.$router.push({ 
            name : 'mercury-save-api-info'
          })
        }
      }
    }
  }
</script>